import styled from 'styled-components';

import spacing from '../../../../Styling/Constants/spacing';

export const Container = styled.div`
    p {
        margin-bottom: ${spacing.sm};
    }
    margin-bottom: ${spacing.md};
`;
